<template>    
    <BaseModal
        :id="'static-update'"
        :title="title"
        :size="'lg'"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit_update(single_object.id, global_index)">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="single_object"
                    :array_options="array_options"
                    :for_update="true"
                />
                <CentralButtons /> 
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources    from    './form_resources'
import FormDynamic      from    '@/components/FormDynamic.vue'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'
import CentralButtons   from    '@/components/CentralButtons'

export default {

    name:   'UpdateModal',
    props: [
        'title',
        'rest_api',
        'notyf',
        'single_object',
        'global_index',
        "array_options",
        "breadcrumb",
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralButtons,
    },

    data(){
        return{
            form_format:    FormResources.form_format,
        }
    },
    
    methods:{
    },

    mounted(){

    }
    
}
</script>